export const countries = [
  {code: 'AF'},
  {code: 'AX'},
  {code: 'AL'},
  {code: 'DZ'},
  {code: 'AS'},
  {code: 'AD'},
  {code: 'AO'},
  {code: 'AI'},
  {code: 'AQ'},
  {code: 'AG'},
  {code: 'AR'},
  {code: 'AM'},
  {code: 'AW'},
  {code: 'AU'},
  {code: 'AT'},
  {code: 'AZ'},
  {code: 'BS'},
  {code: 'BH'},
  {code: 'BD'},
  {code: 'BB'},
  {code: 'BY'},
  {code: 'BE'},
  {code: 'BZ'},
  {code: 'BJ'},
  {code: 'BM'},
  {code: 'BT'},
  {code: 'BO'},
  {code: 'BA'},
  {code: 'BW'},
  {code: 'BV'},
  {code: 'BR'},
  {code: 'IO'},
  {code: 'VG'},
  {code: 'BN'},
  {code: 'BG'},
  {code: 'BF'},
  {code: 'BI'},
  {code: 'KH'},
  {code: 'CM'},
  {code: 'CA'},
  {code: 'CV'},
  {code: 'BQ'},
  {code: 'KY'},
  {code: 'CF'},
  {code: 'TD'},
  {code: 'CL'},
  {code: 'CN'},
  {code: 'CX'},
  {code: 'CC'},
  {code: 'CO'},
  {code: 'KM'},
  {code: 'CG'},
  {code: 'CD'},
  {code: 'CK'},
  {code: 'CR'},
  {code: 'CI'},
  {code: 'HR'},
  {code: 'CW'},
  {code: 'CY'},
  {code: 'CZ'},
  {code: 'DK'},
  {code: 'DJ'},
  {code: 'DM'},
  {code: 'DO'},
  {code: 'EC'},
  {code: 'EG'},
  {code: 'SV'},
  {code: 'GQ'},
  {code: 'ER'},
  {code: 'EE'},
  {code: 'SZ'},
  {code: 'ET'},
  {code: 'FK'},
  {code: 'FO'},
  {code: 'FJ'},
  {code: 'FI'},
  {code: 'FR'},
  {code: 'GF'},
  {code: 'PF'},
  {code: 'TF'},
  {code: 'GA'},
  {code: 'GM'},
  {code: 'GE'},
  {code: 'DE'},
  {code: 'GH'},
  {code: 'GI'},
  {code: 'GR'},
  {code: 'GL'},
  {code: 'GD'},
  {code: 'GP'},
  {code: 'GU'},
  {code: 'GT'},
  {code: 'GG'},
  {code: 'GN'},
  {code: 'GW'},
  {code: 'GY'},
  {code: 'HT'},
  {code: 'HM'},
  {code: 'HN'},
  {code: 'HK'},
  {code: 'HU'},
  {code: 'IS'},
  {code: 'IN'},
  {code: 'ID'},
  {code: 'IQ'},
  {code: 'IE'},
  {code: 'IM'},
  {code: 'IL'},
  {code: 'IT'},
  {code: 'JM'},
  {code: 'JP'},
  {code: 'JE'},
  {code: 'JO'},
  {code: 'KZ'},
  {code: 'KE'},
  {code: 'KI'},
  {code: 'KW'},
  {code: 'KG'},
  {code: 'LA'},
  {code: 'LV'},
  {code: 'LB'},
  {code: 'LS'},
  {code: 'LR'},
  {code: 'LY'},
  {code: 'LI'},
  {code: 'LT'},
  {code: 'LU'},
  {code: 'MO'},
  {code: 'MG'},
  {code: 'MW'},
  {code: 'MY'},
  {code: 'MV'},
  {code: 'ML'},
  {code: 'MT'},
  {code: 'MH'},
  {code: 'MQ'},
  {code: 'MR'},
  {code: 'MU'},
  {code: 'YT'},
  {code: 'MX'},
  {code: 'FM'},
  {code: 'MD'},
  {code: 'MC'},
  {code: 'MN'},
  {code: 'ME'},
  {code: 'MS'},
  {code: 'MA'},
  {code: 'MZ'},
  {code: 'MM'},
  {code: 'NA'},
  {code: 'NR'},
  {code: 'NP'},
  {code: 'NL'},
  {code: 'NC'},
  {code: 'NZ'},
  {code: 'NI'},
  {code: 'NE'},
  {code: 'NG'},
  {code: 'NU'},
  {code: 'NF'},
  {code: 'MK'},
  {code: 'MP'},
  {code: 'NO'},
  {code: 'OM'},
  {code: 'PK'},
  {code: 'PW'},
  {code: 'PS'},
  {code: 'PA'},
  {code: 'PG'},
  {code: 'PY'},
  {code: 'PE'},
  {code: 'PH'},
  {code: 'PN'},
  {code: 'PL'},
  {code: 'PT'},
  {code: 'PR'},
  {code: 'QA'},
  {code: 'RE'},
  {code: 'RO'},
  {code: 'RU'},
  {code: 'RW'},
  {code: 'WS'},
  {code: 'SM'},
  {code: 'ST'},
  {code: 'SA'},
  {code: 'SN'},
  {code: 'RS'},
  {code: 'SC'},
  {code: 'SL'},
  {code: 'SG'},
  {code: 'SX'},
  {code: 'SK'},
  {code: 'SI'},
  {code: 'SB'},
  {code: 'SO'},
  {code: 'ZA'},
  {code: 'GS'},
  {code: 'KR'},
  {code: 'SS'},
  {code: 'ES'},
  {code: 'LK'},
  {code: 'BL'},
  {code: 'SH'},
  {code: 'KN'},
  {code: 'LC'},
  {code: 'MF'},
  {code: 'PM'},
  {code: 'VC'},
  {code: 'SD'},
  {code: 'SR'},
  {code: 'SJ'},
  {code: 'SE'},
  {code: 'CH'},
  {code: 'TW'},
  {code: 'TJ'},
  {code: 'TZ'},
  {code: 'TH'},
  {code: 'TL'},
  {code: 'TG'},
  {code: 'TK'},
  {code: 'TO'},
  {code: 'TT'},
  {code: 'TN'},
  {code: 'TR'},
  {code: 'TM'},
  {code: 'TC'},
  {code: 'TV'},
  {code: 'UM'},
  {code: 'VI'},
  {code: 'UG'},
  {code: 'UA'},
  {code: 'AE'},
  {code: 'GB'},
  {code: 'US'},
  {code: 'UY'},
  {code: 'UZ'},
  {code: 'VU'},
  {code: 'VA'},
  {code: 'VE'},
  {code: 'VN'},
  {code: 'WF'},
  {code: 'EH'},
  {code: 'YE'},
  {code: 'ZM'},
  {code: 'ZW'},
];

export const personalDomainsData = {
  domains: [
    '@163.com',
    '@abluec.com',
    '@aol.com',
    '@att.net',
    '@bellsouth',
    '@bigpond',
    '@btconnect',
    '@btinternet',
    '@charter.net',
    '@comcast',
    '@commongroundinternational',
    '@cox.net',
    '@e-cut',
    '@earthlink',
    '@eircom.',
    '@email.com',
    '@example.com',
    '@free.fr',
    '@gmail.com',
    '@gmx.com',
    '@gmx.de',
    '@googlemail.com',
    '@hotmail',
    '@icloud.com',
    '@iinet.net.au',
    '@juno.com',
    '@laposte.net',
    '@libero.it',
    '@live.ca',
    '@live.co',
    '@mac.com',
    '@mail.com',
    '@mail.ru',
    '@me.com',
    '@msn.com',
    '@myfairpoint',
    '@na.com',
    '@none.com',
    '@optonline',
    '@optusnet',
    '@orange.fr',
    '@outlook',
    '@pac-print',
    '@protonmail',
    '@psychz',
    '@qq.com',
    '@rocketmail',
    '@rogers.com',
    '@sasktel',
    '@sbcglobal',
    '@sfr.fr',
    '@shaw.ca',
    '@shopify',
    '@sky.com',
    '@superchargedsystems',
    '@swimtails.com',
    '@tbd.com',
    '@telus.net',
    '@telusplanet',
    '@test.com',
    '@verizon',
    '@ves.edu',
    '@vianet.ca',
    '@wanadoo',
    '@xtra.co.nz',
    '@yahoo',
    '@yandex',
    '@ymail.com',
  ],
  countries: [
    'US',
    'CA',
    'IN',
    'AE',
    'AT',
    'BE',
    'CH',
    'DE',
    'ES',
    'FR',
    'GB',
    'IE',
    'IT',
    'LU',
    'NL',
    'AF',
    'AO',
    'BG',
    'BH',
    'BJ',
    'CI',
    'CY',
    'CZ',
    'DK',
    'EE',
    'EG',
    'FI',
    'GH',
    'GI',
    'GL',
    'GM',
    'GR',
    'HR',
    'HU',
    'IL',
    'IQ',
    'IR',
    'IS',
    'JO',
    'KE',
    'KW',
    'KZ',
    'LB',
    'LI',
    'LT',
    'LV',
    'MA',
    'MC',
    'MT',
    'MU',
    'NA',
    'NE',
    'NO',
    'OM',
    'PL',
    'PT',
    'QA',
    'RO',
    'RS',
    'RU',
    'SA',
    'SE',
    'SI',
    'SK',
    'SN',
    'TN',
    'TR',
    'UA',
    'VA',
    'ZA',
    'AG',
    'AR',
    'BO',
    'BR',
    'BZ',
    'CL',
    'CO',
    'CR',
    'DO',
    'EC',
    'GT',
    'GY',
    'HN',
    'JM',
    'LC',
    'MX',
    'NI',
    'PA',
    'PE',
    'PY',
    'SV',
    'TT',
    'UY',
    'JP',
    'SG',
    'AU',
    'NZ',
  ],
};

export const consentPrecheckedCountries = ['FR', 'JP', 'MY', 'MX'];
export const implicitCountries = ['US', 'IN', 'IE', 'SG', 'BR', 'HK', 'GB'];
